export type RecallPeriod = "1_year" | "2_years" | "6_months" | "less_6_months";

export const macularOedemas = {
  none: "None",
  "non-centre-involving": "Non-Centre Involving",
  "centre-involving": "Centre Involving",
};

export type MacularOedema = keyof typeof macularOedemas;

export const eyeTestOptions = {
  less_6_months: "Less than 6 months ago",
  "6_12_months": "6-12 months ago",
  "1_2_years": "1-2 years ago",
  over_2_years: "Over 2 years ago",
  unknown_never: "Don't know / never",
};

export type EyeTest = keyof typeof eyeTestOptions;

type CommonEnrolmentValues = {
  title: string;
  first_name: string;
  surname: string;
  dob: string;
  postcode: string;
  ndss: string;
  indigenous: string;
  patient_consent: boolean;
  practice_name: string;
  visual_acuity_right: string;
  visual_acuity_right_normal_with_modifier: string;
  visual_acuity_left: string;
  visual_acuity_left_normal_with_modifier: string;
  diabetic_retinopathy_left: string;
  diabetic_retinopathy_right: string;
  macular_oedema_left: MacularOedema;
  macular_oedema_right: MacularOedema;
  hba1c: string;
  hba1c_unknown: boolean;
  last_eye_test: EyeTest;
  follow_up_sms: boolean;
  follow_up_sms_number: string;
  follow_up_email: boolean;
  follow_up_email_address: string;
  follow_up_post: boolean;
  follow_up_post_address: string;
  recall_months: RecallPeriod;
  date_of_fundus_exam?: string;
  research_participant: boolean;
};

type ResearchParticipantEnrolmentValues = {
  research_participant: true;
  right_eye_image: string;
  left_eye_image: string;
  right_oct_eye_image: string;
  left_oct_eye_image: string;
};

export type ResearchParticipantValues = CommonEnrolmentValues & {
  research_participant: true;
} & ResearchParticipantEnrolmentValues;
export type NonParticipantValues = CommonEnrolmentValues & {
  research_participant: false;
};

export type EnrolmentValues = ResearchParticipantValues | NonParticipantValues;
